import { ArrowUpIcon, ArrowDownIcon, SwapIcon } from '@coursera/cds-icons';

import { useTableContext } from '@core/table/features/TableContext';

export type Props = {
  accessor: string;
  sortable?: boolean;
};

const SortIcon = ({ accessor, sortable }: Props) => {
  const { sort } = useTableContext();

  if (!sortable) {
    return null;
  }
  if (sort?.key !== accessor) {
    return <SwapIcon size="large" />;
  }
  if (sort?.direction === 'ascending') {
    return <ArrowUpIcon size="large" />;
  }
  return <ArrowDownIcon size="large" />;
};

export default SortIcon;
